import { Reveal, Eyebrow } from "../Reveal";
import { PROJECT_CATEGORIES, IMAGES } from "../../lib/data";

const ProjectsGrid = ({ limit }) => {
  const items = limit ? PROJECT_CATEGORIES.slice(0, limit) : PROJECT_CATEGORIES;
  return (
    <section data-testid="projects-section" className="border-t border-black/10 bg-ink-surface">
      <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-32">
        <Reveal>
          <Eyebrow>Projects &amp; Capabilities</Eyebrow>
          <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
            <h2 className="max-w-xl font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
              Commercial Projects. Practical Results.
            </h2>
            <p className="max-w-md text-sm leading-relaxed text-mist md:text-base">
              The categories of work we take on for petroleum retail and related commercial
              properties. Imagery shown is representative of the environments we service.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((project, i) => {
            const img = IMAGES[project.image];
            return (
              <Reveal key={project.title} delay={(i % 4) * 0.08} className="h-full">
                <div
                  data-testid={`project-card-${project.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="group h-full border border-black/10 bg-white"
                >
                  <div className="relative overflow-hidden">
                    <img
                      src={img.url}
                      alt={img.alt}
                      loading="lazy"
                      className="aspect-[4/3] w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <span className="absolute left-0 top-0 bg-coal px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.2em] text-ember">
                      {project.tag}
                    </span>
                  </div>
                  <div className="p-5">
                    <h3 className="font-display text-base font-bold tracking-tight">
                      {project.title}
                    </h3>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProjectsGrid;
